"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function MorningStories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const testimonials = [{
    author: "The Michelin Guide",
    quote: "A masterclass in restraint. Every ingredient on the plate has a purpose, singing with the clarity of the Danish coastline.",
    position: "Culinary Critique"
  }, {
    author: "Gastronomy Today",
    quote: "NordicBite isn't just a meal; it's a sensory immersion into the avant-garde spirit of Copenhagen's culinary evolution.",
    position: "International Press"
  }, {
    author: "Chef Erik Sørensen",
    quote: "The interplay of smoke, salt, and fermentation here creates a profile that is both ancient and startlingly modern.",
    position: "Guest Contributor"
  }, {
    author: "Nordic Travel Review",
    quote: "Minimalism at its most delicious. The focus on seasonal foraging brings the forest directly to the table.",
    position: "Travel & Leisure"
  }];
  return <section data-section-id="30989" id="voices-of-the-gastronomy" ref={ref} className={cn("bg-background py-24 transition-opacity duration-1000 dark", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-6 max-w-5xl">
        <div className="mb-12 text-center md:text-left">
          <h2 className="font-mono text-[10px] font-medium tracking-[0.3em] uppercase text-primary/80">
            Voices of the Gastronomy
          </h2>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent>
            {testimonials.map((item, i) => <CarouselItem key={i} data-index={i} className="md:basis-full">
                <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-start">
                  <div className="relative flex-1">
                    <Quote className="absolute -top-8 -left-4 md:-left-8 size-12 md:size-16 text-primary/10 rotate-180" />
                    
                    <blockquote className="relative z-10">
                      <p className="font-serif text-3xl md:text-5xl lg:text-6xl italic leading-[1.1] text-foreground tracking-tight">
                        <span className="text-primary/40 align-top text-6xl lg:text-7xl leading-none mr-2">
                          &ldquo;
                        </span>
                        {item.quote}
                        <span className="text-primary/40 align-bottom text-6xl lg:text-7xl leading-none ml-2">
                          &rdquo;
                        </span>
                      </p>
                    </blockquote>

                    <div className="mt-8 md:mt-12 pl-4 border-l border-primary/30">
                      <cite className="not-italic block font-mono text-[11px] font-medium text-foreground uppercase tracking-[0.2em]">
                        {item.author}
                      </cite>
                      <span className="block font-serif italic text-muted-foreground text-sm mt-1">
                        {item.position}
                      </span>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex justify-end gap-4 mt-12 pr-4">
            <CarouselPrevious variant="outline" className="static translate-none size-12 rounded-full border-primary/20 bg-transparent text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-500" />
            <CarouselNext variant="outline" className="static translate-none size-12 rounded-full border-primary/20 bg-transparent text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-500" />
          </div>
        </Carousel>
      </div>
    </section>;
}